import { createAction } from 'redux-actions'
import Api from '../Api'

import { exportPDF } from '../components/export'

import { setAlert } from './alerts'
import { createRiderItems } from './rider-item'
import { createRiderStageplan } from './rider-stageplan'

export const SAVE_RIDER = createAction('SAVE_RIDER')
export const RIDER_SAVING = createAction('RIDER_SAVING')

export const REQUEST_RIDER = createAction('REQUEST_RIDER')
export const RECEIVE_RIDER = createAction('RECEIVE_RIDER')
export const CREATE_RIDER = createAction('CREATE_RIDER')
export const EDIT_RIDER = createAction('EDIT_RIDER')
export const SHARE_RIDER = createAction('SHARE_RIDER')
export const REMOVE_RIDER_SHARE = createAction('REMOVE_RIDER_SHARE')
export const REQUEST_RIDER_EXPORT = createAction('REQUEST_RIDER_EXPORT')
export const RECEIVE_RIDER_EXPORT = createAction('RECEIVE_RIDER_EXPORT')
export const DELETE_RIDER = createAction('DELETE_RIDER')

export const fetchRider = (id) => {
  return (dispatch) => {
    dispatch(REQUEST_RIDER())

    return Api.viewRider(id)
      .then(response => dispatch(RECEIVE_RIDER({data: response.data})))
      .catch(error => {
        dispatch(RECEIVE_RIDER(error.response))
        dispatch(setAlert(error.response.data.message, undefined, 'error'))
      })
  }
}

export const createRider = (title) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return Api.createRider(title)
      .then(response => {
        dispatch(CREATE_RIDER({data: response.data}))

        const { id } = response.data

        dispatch(createRiderItems(
          id,
          {
            class: 'instrument',
            group: 'input',
            type: 'guitar',
            title: 'Your first demo guitar',
            position: 1
          },
          [
            {
              class: 'equipment',
              group: 'input',
              type: 'microphone',
              title: 'Microphone',
              position: 1
            },
            {
              class: 'equipment',
              group: 'input',
              type: 'stand',
              title: 'Stand',
              position: 2
            },
            {
              class: 'equipment',
              group: 'input',
              type: 'cable',
              title: 'Cable',
              position: 3
            },
            {
              class: 'equipment',
              group: 'input',
              type: 'insert',
              title: 'Insert',
              position: 4
            }
          ]
        ))

        dispatch(createRiderItems(
          id,
          null,
          [
            {
              group: 'output',
              class: 'monitor',
              type: 'monitor',
              title: 'Monitor'
            },
            {
              group: 'output',
              class: 'monitor',
              type: 'monitor',
              title: 'Monitor'
            },
            {
              group: 'output',
              class: 'monitor',
              type: 'monitor',
              title: 'Monitor'
            }
          ]
        ))

        dispatch(createRiderStageplan(
          id,
          {
            title: 'minu stageplan',
            description: 'stageplani kirjeldus',
            width: '1000',
            height: '500'
          }
        ))
      })
      .catch(error => dispatch(setAlert('Sorry, we were unable to create this rider.', undefined, 'error')))
  }
}

export const editRider = (id, data) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(EDIT_RIDER(Api.editRider(id, data)))
  }
}

export const shareRider = (riderId, email) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(SHARE_RIDER(Api.shareRider(riderId, email)))
  }
}

export const removeRiderShare = (riderId, email) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(REMOVE_RIDER_SHARE(Api.removeRiderShare(riderId, email)))
  }
}

export const exportRider = (selector) => {
  return (dispatch) => {
    dispatch(REQUEST_RIDER_EXPORT())

    return exportPDF(selector)
      .then(response => {
        dispatch(RECEIVE_RIDER_EXPORT({data: response.data}))
        dispatch(setAlert('We have successfully exported your rider', undefined, 'success'))
      })
      .catch(error => dispatch(setAlert('Sorry, we were unable to export this rider.', undefined, 'error')))
  }
}

export const deleteRider = (riderId) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(DELETE_RIDER(Api.deleteRider(riderId)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/rider.js